import { token } from "../store/token.js";
import { permissions } from "../store/permissions.js";
import { get } from "svelte/store";

/**
 * Handle API response errors, including 403 Insufficient Permissions / FORBIDDEN
 * Returns parsed JSON if successful, throws error otherwise.
 * Uses data.message || data.error so both API shapes (code/message vs error/message) work.
 */
export const handleApiResponse = async (response) => {
    const data = await response.json();
    const message = data.message || data.error || `HTTP ${response.status}`;

    if (!response.ok) {
        // Handle 401 - not logged in or token expired
        if (response.status === 401) {
            permissions.clear();
            token.set("");
            throw new Error(data.message || "Session expired. Please log in again.");
        }

        // Handle 403 - insufficient permissions (code or error field)
        if (response.status === 403 && (data.code === "INSUFFICIENT_PERMISSIONS" || data.error === "FORBIDDEN")) {
            throw new Error(`Access denied: ${data.message || "You don't have permission to perform this action."}`);
        }

        throw new Error(message);
    }

    return data;
};

/**
 * Make an authenticated API request
 */
export const apiRequest = async (url, options = {}) => {
    const currentToken = get(token);
    
    const response = await fetch(url, {
        ...options,
        headers: {
            Authorization: "Bearer " + currentToken,
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
    
    return handleApiResponse(response);
};

export const fetch_device_types = async (userToken) => {
    const response = await fetch(
        `${process.env.API_ROOT}/admin/device-type/list`,
        {
            headers: {
                Authorization: "Bearer " + userToken
            }
        }
    );
    const data = await response.json();
    return data.device_types || [];
};

export const create_impersonation_token = async (userId) => {
    return apiRequest(
        `${process.env.API_ROOT}/admin/user/${encodeURIComponent(userId)}/impersonate`,
        { method: "POST" }
    );
};

export const fetch_user_list = async (
    userToken,
    deviceType = null,
    trialStatus = null
) => {
    console.log('fetching users', userToken)
    let user_list = {
        records: []
    };

    let params = [];
    if (deviceType) params.push(`device_type=${encodeURIComponent(deviceType)}`);
    if (trialStatus) params.push(`${trialStatus}=true`);

    let url = `${process.env.API_ROOT}/admin/user/list`;
    if (params.length > 0) url += `?${params.join('&')}`;

    const response = await fetch(
        url,
        {
            headers: {
                Authorization: "Bearer " + userToken
            }
        }
    );
    user_list = await response.json();
    return user_list;
}